var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('div',{class:[
      'box is-paddingless',
      _vm.$style.container,
      _vm.getClassNames(),
      _vm.isBorderless ? _vm.$style.borderless : ''
    ]},[_c('div',{class:_vm.$style.tableScroll},[_c('table',{staticClass:"table is-fullwidth",class:_vm.tableClasses},[_c('thead',[_vm._t("header")],2),_c('tbody',[_vm._t("body")],2)])]),(_vm.$slots.footer)?_c('div',{class:_vm.$style.tableFooter},[_c('table',{staticClass:"table is-fullwidth",class:_vm.tableClasses},[_c('tfoot',[_vm._t("footer")],2)])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }